import { escapeHtml } from '../lib/html.js';
import { statusPillClass } from '../lib/status.js';
import { getSession } from '../lib/auth.js';
import { listAdmins } from '../lib/admins.js';
import { buildHref } from '../lib/router.js';
import { paginate, LIST_PAGE_SIZE } from '../lib/pagination.js';
import { renderPager } from './pager.js';

let cache = [];
let loaded = false;
let loading = false;
let loadError = '';

export function getCachedAdmin(id) {
  return cache.find((u) => String(u.id) === String(id)) || null;
}

export async function refreshAdmins() {
  loading = true;
  loadError = '';
  try {
    cache = await listAdmins();
    loaded = true;
  } catch (err) {
    loadError = err.message || 'Não foi possível carregar os administradores.';
    cache = [];
    loaded = true;
  } finally {
    loading = false;
  }
  return cache;
}

function statusLabel(status) {
  const key = String(status || '').toUpperCase();
  if (key === 'ACTIVE') return 'ativo';
  if (key === 'INACTIVE') return 'pendente';
  return String(status || '—').toLowerCase();
}

function roleLabel(role) {
  const key = String(role || '').toLowerCase();
  if (key === 'master') return 'master';
  return 'admin';
}

function fmtWhen(iso) {
  if (!iso) return '—';
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return '—';
  return dt.toLocaleDateString('pt-BR');
}

export function renderAdmins({ page = 1, onNeedRefresh } = {}) {
  if (!loaded && !loading) {
    refreshAdmins().then(() => onNeedRefresh?.());
  }
  if (!loaded || loading) {
    return `<div class="empty-state">Carregando administradores…</div>`;
  }
  if (loadError) {
    return `<div class="empty-state">${escapeHtml(loadError)}</div>`;
  }

  const me = getSession();
  const pg = paginate(cache, page, LIST_PAGE_SIZE);
  const rows = pg.total
    ? pg.items.map((u) => {
      const st = statusLabel(u.status);
      const mine = me?.id && String(me.id) === String(u.id);
      return `<tr>
        <td><div class="cell-title">${escapeHtml(u.name || '—')}</div><div class="cell-sub">${escapeHtml(u.email || '')}</div></td>
        <td>${escapeHtml(roleLabel(u.role))}</td>
        <td><span class="pill ${statusPillClass(st)}">${escapeHtml(st)}</span></td>
        <td class="cell-sub">${fmtWhen(u.created_at)}</td>
        <td>
          <div class="row-actions">
            <button type="button" class="icon-btn" data-action="send-password" data-type="admins" data-id="${escapeHtml(u.id)}">enviar senha</button>
            <button type="button" class="icon-btn" data-action="edit" data-type="admins" data-id="${escapeHtml(u.id)}">editar</button>
            <button type="button" class="icon-btn danger" data-action="delete" data-type="admins" data-id="${escapeHtml(u.id)}" ${mine ? 'disabled title="Você não pode remover a própria conta"' : ''}>excluir</button>
          </div>
        </td>
      </tr>`;
    }).join('')
    : `<tr><td colspan="5" class="empty-state">Nenhum administrador cadastrado.</td></tr>`;

  return `
    <div class="table-toolbar">
      <span class="cell-sub">${pg.total} administrador(es) · cadastro só por convite, sem inscrição pública</span>
    </div>
    <div class="panel-box"><div class="table-scroll"><table>
      <thead><tr><th>Administrador</th><th>Papel</th><th>Status</th><th>Desde</th><th></th></tr></thead>
      <tbody>${rows}</tbody>
    </table></div></div>
    ${pg.total ? renderPager({
      id: 'admin',
      page: pg.page,
      totalPages: pg.totalPages,
      from: pg.from,
      to: pg.to,
      total: pg.total,
      label: 'administrador(es)',
      hrefFor: (n) => buildHref({ section: 'admin', page: n }),
    }) : ''}`;
}
